export default __webpack_public_path__ + "static/main4-9204b908a28e392a580abadf2ccbfcc2.png";